import { z } from 'zod';

import { LOGIN_RECAPTCHA_FIELD } from '../consts';

const LoginRecaptchaErrorSchema = z.object({
  fields: z.object({
    [LOGIN_RECAPTCHA_FIELD]: z.array(z.string()).min(1)
  })
});

/** True when the login 400 payload carries a reCAPTCHA field error. */
export const hasLoginRecaptchaError = (error: unknown) => LoginRecaptchaErrorSchema.safeParse(error).success;
